// extracted by mini-css-extract-plugin
export default {"form":"ChangeBatchTypeForm_form__Z3aGy","select":"ChangeBatchTypeForm_select__kD0pp","label":"ChangeBatchTypeForm_label__21-3s"};